import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    sequences: string;
    compositions: string;
    browse: string;
    exportsInProgressLabel: (count: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Sequences tab label */
            sequences: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PremiereTabs.sequences?c=1yh9sx4n7jfjd", defaultMessage: "Sequences" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Compositions tab label */
            compositions: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PremiereTabs.compositions?c=fmvx92p7a91d", defaultMessage: "Compositions" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Browse tab label */
            browse: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PremiereTabs.browse?c=m1w8g8hjhd97", defaultMessage: "Browse" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for the in-progress exports badge */
            exportsInProgressLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "PremiereTabs.exportsInProgressLabel?c=3c76t0v6vgwyu", defaultMessage: "{count, plural, one {1 export in progress} other {{count} exports in progress}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
